import React from 'react';
import classNames from 'classnames';

interface ProgressProps {
  value: number;
  className?: string;
  max?: number;
}

export const Progress = ({ value, className, max = 100 }: ProgressProps) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <div
      className={classNames(
        'relative h-2 w-full overflow-hidden rounded-full bg-neutral-200',
        className,
      )}
    >
      <div
        className="h-full w-full flex-1 bg-black transition-all"
        style={{ transform: `translateX(-${100 - percentage}%)` }}
      />
    </div>
  );
};
